import { render } from "./WorkOvertime.vue?vue&type=template&id=2d163f7e"
import script from "./WorkOvertime.vue?vue&type=script&lang=js"
export * from "./WorkOvertime.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/TimeTracker_1.0/TimeTracker_1.0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__